// Generated from SVG to Code Figma Plugin

export const ProductLinePic = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.0007 4H6.00065C4.52789 4 3.33398 5.19391 3.33398 6.66667V17.3333C3.33398 18.8061 4.52789 20 6.00065 20H18.0007C19.4734 20 20.6673 18.8061 20.6673 17.3333V12.6667V6.66667C20.6673 5.19391 19.4734 4 18.0007 4Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M3.33398 11.9998C7.33398 11.3331 14.0007 12.6664 14.0007 19.9998"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <circle cx="15.8659" cy="9.86686" r="1.91667" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
